import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";
import { loadingStart, loadingSuccess, loadingFailure } from "./loading";
import { GetUserBlance } from "./userbal";

const initialState = {
  data: null,
  loading: false,
  error: null,
};
const authCraditSlice = createSlice({
  name: "cashout",
  initialState,
  reducers: {
    requestStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    ApiSuccess: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    requestFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.data = null;
    },
  },
});

export const { requestStart, ApiSuccess, requestFailure } =
  authCraditSlice.actions;

export const CashoutSlice = (data) => async (dispatch) => {
  try {
    dispatch(requestStart());
    const response = await axios.post(`/private/cashout`, data);
    dispatch(GetUserBlance());
    dispatch(ApiSuccess(response?.data));
  } catch (err) {
    toast.error(err?.response?.data?.message || err.message || " failed!");

    dispatch(
      requestFailure(err?.response?.data?.message || "Something went wrong!")
    );
  }
};
export const GetCashoutlist = (user) => async (dispatch) => {
  try {
    dispatch(requestStart());
    const GetCashoutlist = await axios.get(`/private/cashout`);
    if (GetCashoutlist?.data) {
      dispatch(GetUserBlance());
      dispatch(ApiSuccess(GetCashoutlist?.data));
    }
  } catch (err) {
    toast.error(err?.response?.data?.message || err.message || " failed!");
    dispatch(
      requestFailure(err?.response?.data?.message || "Something went wrong!")
    );
  }
};
export default authCraditSlice.reducer;
